module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('el-form', [_c('el-form-item', {
    attrs: {
      "label": "生成注册码"
    }
  }, [_c('el-switch', {
    model: {
      value: (_vm.delivery),
      callback: function($$v) {
        _vm.delivery = $$v
      },
      expression: "delivery"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "注册码："
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "30%"
    },
    attrs: {
      "placeholder": "请牢记此处注册码",
      "disabled": true
    },
    model: {
      value: (_vm.code),
      callback: function($$v) {
        _vm.code = $$v
      },
      expression: "code"
    }
  }), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "success"
    },
    on: {
      "click": _vm.onSubmit
    }
  }, [_vm._v("生成注册码")]), _vm._v(" "), _c('el-button', {
    staticClass: "btn",
    attrs: {
      "type": "warning",
      "data-clipboard-text": _vm.code
    },
    on: {
      "click": _vm.copy
    }
  }, [_vm._v("复制注册码")])], 1), _vm._v(" "), _c('el-form-item'), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "推荐人："
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "30%"
    },
    attrs: {
      "filterable": "",
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.phone),
      callback: function($$v) {
        _vm.phone = $$v
      },
      expression: "phone"
    }
  }, _vm._l((_vm.options), function(item) {
    return _c('el-option', {
      key: item.index,
      attrs: {
        "label": item.name + item.mobileNumber,
        "value": item.mobileNumber + '@' + item.id
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "margin-left": "68px"
    }
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.send
    }
  }, [_vm._v("发送验证码到手机")])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d633b4ea","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/view/subscribeCode/createCode.vue
// module id = 1045
// module chunks = 2